import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../Translations';
import LearningCollectionStore from '../../Store';
import { ProductLicensesResource } from '../../../Types';
import Right from './Right';
import Left from './Left';
import { onlyAsConfiguredActiveLicense } from '../../Types';

interface Props {
  store: LearningCollectionStore;
  productLicensesResource: ProductLicensesResource;
}

class ChooseProductLicenseReady extends React.Component<Props, {}> {
  componentDidMount() {
    const activeLicenses = this.props.productLicensesResource.payload.activeProductLicenses;

    onlyAsConfiguredActiveLicense(activeLicenses).map((activeLicenses) => {
      this.props.store.selectProductLicense(activeLicenses.first.payload.id);
      this.props.store.reloadAllExperiences();
    });
  }

  render() {
    const { store, productLicensesResource } = this.props;

    return (
      <div className="mx-auto w-full max-w-clientPortalMaxWidth">
        <div className="px-2.5 pb-4 md:flex-row lg:px-12">
          <div className="pt-10">
            <h2 className="text-3xl font-semibold text-gray-900">
              <T kind="Start designing your collection" />
            </h2>
            <div className="flex items-center space-x-5">
              <p className="pt-1 text-[#2B2B2B]">
                <T kind="Start by defining your preferences for this collection ..." />
              </p>
            </div>
          </div>
          <div className="pt-8">
            <h4 className="text-lg font-semibold text-black">
              <T kind="Choose the license aligned with your leadership development goals." />
            </h4>
            <div className="flex items-center space-x-5">
              <p className="pt-1 text-[#2B2B2B]">
                <T kind="Your selection determines the programs, resources, and ..." />
              </p>
            </div>
          </div>
          <div className="flex justify-between">
            <Left store={store} productLicensesResource={productLicensesResource} />
            <Right store={store} />
          </div>
        </div>
      </div>
    );
  }
}

export default observer(ChooseProductLicenseReady);
